export default __webpack_public_path__ + "static/media/money-icon.eba084e6.svg";